export default class GeneralSolutionFallbackError extends Error{
	constructor(message, data) {
		super(message);
		this.name = "GeneralSolutionFallbackError"
		this.data = data;
	}
}